import css from "@styled-system/css";
import { position, PositionProps, layout, LayoutProps } from "styled-system";
import styled from "styled-components";

type StyleOverlayProps = PositionProps &
  LayoutProps & {
    css?: string;
  };

const StyledDiv = styled.div<
  Partial<StyleOverlayProps & { index: number; sectionsCount: number }>
>`
  position: relative;
  &:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid white;
    position: absolute;
    left: calc(
      ${(props) =>
          props.index === 0 && props.sectionsCount && props.sectionsCount > 1
            ? "20%"
            : props.index === 1 &&
              props.sectionsCount &&
              props.sectionsCount > 2
            ? "45%"
            : "50%"} - 6px
    );
    top: -6px;
  }
  ${css({
    boxShadow: "hover",
    backgroundColor: "background-default-color",
    borderRadius: 1,
    zIndex: 1,
  })}
  ${position}
  ${layout}
  ${(props) => props.css}
`;

export default function Popover({ children, ...props }: any) {
  return <StyledDiv {...props}>{children}</StyledDiv>;
}
